<template>
  <div class="littleselect">
    <div class="row">
      <div class="col-md-6">
        <h4 style="font-weight: bold;color:#3d464c;">
          {{ $t($route.name) }}
          <span v-if="$route.params.id != undefined">№{{ $route.params.id }}</span>
          {{ Dates(datas.created_at) }}
        </h4>
      </div>
      <div class="col-md-6 end">
        <button type="button" v-if="$route.params.id!=undefined && settedrule.change==true" @click="Change()"
        class="btn btn-primary change">{{$t('Ўзгартириш')}}</button>
        <router-link class="btn btn-danger needt" :to="{ path: '/production/index' }">
          <button type="button" class="closebutton needt">
          <b-icon icon="x-lg"></b-icon>
          </button>
        </router-link>
      </div>
    </div>
    <div class="rowform">
      <div class="col-md-4 topheader">
        <span>
          <label>Склад</label>
            <v-select
              :clearable="false"
              class="form-control-sm required md-input"
              :options="skladlist"
              v-model="datas.sklad_id"
            :disabled="skladhave"
              :reduce="name => name.id"
              label="name"
            >
              <template #search="{ attributes, events }">
                <input
                  class="vs__search"
                  v-bind="attributes"
                  v-on="events"
                  aria-activedescendant="null"
                />
              </template>
              <template v-slot:no-options="{ search, searching }">
                <template v-if="searching">
                  <em
                    ><b>{{ search }}</b></em
                  >
                  {{ $t("бўйича маьлумот йўқ") }}
                </template>
                <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
              </template>
            </v-select>
        </span>
      </div>
      <!-- <div class="col-md-4 topheader">
        <span>
          <label>Расход</label>
            <div style="border-bottom:1px solid silver">
            {{ datas.rasxod_summa | numFormat }}
            </div>
        </span>
      </div> -->
      <div class="col-md-2 topheader">
        <span>
          <label>Курс</label>
            <div style="border-bottom:1px solid silver">
            <input :disabled="changedisabled" type="number" class="form-control-sm needt"  v-model="datas.dollar_rate">
            </div>
        </span>
      </div>
      <div class="col-md-6 topheader">
        <span>
          <label>Комментарий</label>
              <input
              :disabled="changedisabled"
                v-model="datas.comment"
                class="needt"
                type="text"
              >
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <b>Товар </b>
        <button :disabled="changedisabled" class="mybtn btn addrow littlebutton" type="button" @click="Addtable()">
          +<sup>F1</sup>
        </button>
        <button :disabled="changedisabled" class="mybtn btn littlebutton" type="button" @click="Upproduct()">
          <b-icon icon="arrow-up"></b-icon><sup></sup>
        </button>
        <button :disabled="changedisabled" class="mybtn btn littlebutton" type="button" @click="Downproduct()">
          <b-icon icon="arrow-down"></b-icon><sup></sup>
        </button>
        <div class="table100percent">
          <md-card>
            <md-card-content>
              <table class="table table-bordered">
                <thead >
                  <tr>
                    <th class="column0">№</th>
                    <th class="column2">Товар</th>
                    <th class="column1">{{ $t("Кол.") }}</th>
                    <th class="column1">{{ $t("Қолдиқ") }}</th>
                    <th class="column1">{{ $t("Расход") }}</th>
                    <th class="column1">{{ $t("Серё") }} {{ $t("нарх") }} </th>
                    <th class="column1">{{ $t("Нарх") }} ({{ $t("Кирим") }})</th>
                    <th class="column1-5 kol">Сумма ({{ $t("Кирим") }})</th>
                    <th class="column1">{{ $t("Чакана") }} (%)</th>
                    <th class="column1">{{ $t("Чакана") }} ({{ $t("Нарх") }})</th>
                    <th class="column1">{{ $t("Чакана") }} ({{ $t("Нарх") }} $)</th>
                    <th class="column1">{{ $t("Улгуржи") }} (%)</th>
                    <th class="column1">{{ $t("Улгуржи") }} ({{ $t("Нарх") }})</th>
                    <th class="column1">{{ $t("Улгуржи") }} ({{ $t("Нарх") }} $)</th>
                    <th class="column1"></th>
                  </tr>
                </thead>
                <tbody style="overflow: hidden;">
                  <div
                    style="overflow-y: scroll; height: 22vh !important; width: 100%;"
                  >
                    <tr
                      :style="{ height: `${index / 1000 + 10}px` }"
                      v-for="(item, index) in datas.production_doc_calc"
                      :key="index"
                      @click="settedindex=index;"
                    >
                      <td class="column0" :style="[settedindex == index ? { border: '1px solid green' } : {border:'1px solid #dee2e6'}]">{{ index + 1 }}</td>
                      <td class="column2" :style="[settedindex == index ? { border: '1px solid green' } : {border:'1px solid #dee2e6'}]">
                        <v-select
                        :disabled="changedisabled"
                          v-if="productlist != null"
                          :filter-by="$store.state.myFilter"
                          :clearable="false"
                          class="form-control-sm required"
                          @search="query => (search = query)"
                          :options="paginated"
                          menu-props="auto"
                          v-model="item.product_id"
                          :reduce="extra_name => extra_name.id"
                          label="extra_name"
                          @input="Productchange(index)"
                        >
                          <template #list-footer>
                            <li style="text-align: center;font-weight:bold;">
                              f4 {{ $t("умумий рўйхат") }}
                            </li>
                          </template>
                          <template #selected-option-container="{option}">
                            <div class="vs__selected">
                              <span v-if="typeof option.extra_name === 'number'">{{
                                Label(option.extra_name)
                              }}</span
                              ><span v-else>{{ option.extra_name }}</span>
                            </div>
                          </template>
                          <template #open-indicator="{ attributes }">
                            <span v-bind="attributes"></span>
                            <button
                            :disabled="changedisabled"
                              type="button"
                              class="modallist"
                              @click="Selectproduct(index)"
                            >
                              <b-icon icon="three-dots"></b-icon>
                            </button>
                          </template>
                          <template #selected-option="{ extra_name }">
                            <div style="position: absolute">
                              {{ extra_name }}
                            </div>
                          </template>
                          <template v-slot:no-options="{ search, searching }">
                            <template v-if="searching">
                              <em
                                ><b>{{ search }}</b></em
                              >
                              {{ $t("бўйича маьлумот йўқ") }}
                              <button
                                type="button"
                                class="pluss"
                                @click="CreateProduct(index, search)"
                              >
                                +</button
                              ><b>Insert</b>
                            </template>
                            <em style="opacity: 0.5" v-else>{{
                              $t("Маьлумот йўқ")
                            }}</em>
                          </template>
                          <template #search="{ search, searching }">
                            <template v-if="searching">
                              <em
                                ><b>{{ search }}</b></em
                              >
                              <input
                                class="vs__search"
                                v-bind="attributes"
                                v-on="events"
                              />
                            </template>
                          </template>
                        </v-select>
                      </td>
                      <td class="column1" :style="[settedindex == index ? { border: '1px solid green' } : {border:'1px solid #dee2e6'}]">
                        <vue-numeric
                        :disabled="changedisabled"
                          separator="space"
                          style="text-align: center;"
                          v-bind:precision="3"
                          v-model="item.count"
                          class="table-input"
                          @change="Changecount(index)"
                        ></vue-numeric>
                      </td>
                      <td class="column1" style="text-align: center;" :style="[settedindex == index ? { border: '1px solid green' } : {border:'1px solid #dee2e6'}]">
                        {{ item.current_balance | numFormat }}
                      </td>
                      <td class="column1" :style="[settedindex == index ? { border: '1px solid green' } : {border:'1px solid #dee2e6'}]">
                        <vue-numeric
                        :disabled="changedisabled"
                          separator="space"
                          style="text-align: center;"
                          v-bind:precision="3"
                          v-model="item.rasxod_summa"
                          class="table-input"
                          @change="ChangeRasxod(index)"
                        ></vue-numeric>
                      </td>
                      <td class="column1" style="text-align: center;" :style="[settedindex == index ? { border: '1px solid green' } : {border:'1px solid #dee2e6'}]">
                        {{ item.seryo_summa | numFormat }}
                      </td>
                      <td class="column1" style="text-align: center;" :style="[settedindex == index ? { border: '1px solid green' } : {border:'1px solid #dee2e6'}]">
                        {{ item.debit_price | numFormat }}
                      </td>
                      <td class="column1-5 kol" :style="[settedindex == index ? { border: '1px solid green' } : {border:'1px solid #dee2e6'}]">{{ item.debit_summa | numFormat }}</td>
                      <td class="column1" :style="[settedindex == index ? { border: '1px solid green' } : {border:'1px solid #dee2e6'}]">
                        <input type="number"
                        :disabled="changedisabled"
                          separator="space"
                          style="text-align: center;"
                          v-bind:precision="1"
                          v-model="item.chakana_percent"
                          class="table-input"
                          @input="Changepercentchakana(index)"
                        >
                      </td>
                      <td class="column1" :style="[settedindex == index ? { border: '1px solid green' } : {border:'1px solid #dee2e6'}]">
                        <vue-numeric
                        :disabled="changedisabled"
                          style="text-align: center;"
                          separator="space"
                          v-bind:precision="2"
                          v-model="item.chakana_price"
                          class="table-input"
                          @input="Changepricechakana(index)"
                        ></vue-numeric>
                      </td>
                      <td class="column1" :style="[settedindex == index ? { border: '1px solid green' } : {border:'1px solid #dee2e6'}]" >
                        <vue-numeric :disabled="changedisabled" style="text-align: center;" separator="space" v-bind:precision="2"
                          v-model="item.chakana_dollar_price" class="table-input needt" @change="Changepricechakanadollar(index)">
                        </vue-numeric>
                      </td>
                      <td class="column1" :style="[settedindex == index ? { border: '1px solid green' } : {border:'1px solid #dee2e6'}]">
                        <input type="number"
                        :disabled="changedisabled"
                          separator="space"
                          style="text-align: center;"
                          v-bind:precision="1"
                          v-model="item.optom_percent"
                          class="table-input"
                          @input="Changepercentoptom(index)"
                          >
                      </td>
                      <td class="column1" :style="[settedindex == index ? { border: '1px solid green' } : {border:'1px solid #dee2e6'}]">
                        <vue-numeric
                        :disabled="changedisabled"
                          style="text-align: center;"
                          separator="space"
                          v-bind:precision="2"
                          v-model="item.optom_price"
                          class="table-input"
                          @blur="Addtable()"
                          @change="Changepriceoptom(index)"
                        ></vue-numeric>
                      </td>
                      <td class="column1" :style="[settedindex == index ? { border: '1px solid green' } : {border:'1px solid #dee2e6'}]" >
                        <vue-numeric :disabled="changedisabled" style="text-align: center;" separator="space" v-bind:precision="2"
                        v-model="item.optom_dollar_price" class="table-input needt" @change="Changepriceoptomdollar(index)">
                      </vue-numeric>
                      </td>
                      <td class="column1" :style="[settedindex == index ? { border: '1px solid green' } : {border:'1px solid #dee2e6'}]">
                        <a v-if="changedisabled==false"
                          href="javascript:void(0)"
                          class="circul trash"
                          @click="Trashitem(index)"
                        >
                          <b-icon icon="trash"></b-icon>
                        </a>
                      </td>
                    </tr>
                  </div>
                </tbody>
              </table>
            </md-card-content>
          </md-card>
        </div>
      </div>
      <div class="col-md-12">
          <b>{{$t('Хом ашё')}} </b>
          <button :disabled="changedisabled" class="mybtn btn addrowchild littlebutton needt" type="button" @click="Addtablechild()">
          +<sup>F2</sup>
        </button>
        <div class="table100percent">
          <md-card>
            <md-card-content>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th class="column0">№</th>
                <th class="column2">Товар</th>
                <th class="column1">{{ $t("Кол.") }}</th>
                <th class="column1">{{ $t("Қолдиқ") }}</th>
                <th class="column1">{{ $t("Нарх") }}</th>
                <th class="column1-5" style="text-align: center;">Сумма</th>
                <th class="column0"></th>
              </tr>
            </thead>
            <tbody style="overflow: hidden;">
              <div
              v-if="datas.production_doc_calc[settedindex]"
                style="overflow-y: scroll; height: 20vh!important; width: 100%!important;"
              >
                <tr
                  v-for="(item, index) in datas.production_doc_calc[settedindex].production_doc_product"
                  :key="index"
                >
                  <td class="column0">{{ index + 1 }}</td>
                  <td class="column2">
                    <v-select
                    :disabled="changedisabled"
                      v-if="productlist != null"
                      :filter-by="$store.state.myFilter"
                      :clearable="false"
                      class="form-control-sm required"
                      @search="query => (search = query)"
                      :options="paginated"
                      menu-props="auto"
                      v-model="item.product_id"
                      :reduce="extra_name => extra_name.id"
                      label="extra_name"
                      @input="Productchangechild(index)"
                    >
                      <template #list-footer>
                        <li style="text-align: center;font-weight:bold;">
                          f4 {{ $t("умумий рўйхат") }}
                        </li>
                      </template>
                      <template #selected-option-container="{option}">
                        <div class="vs__selected">
                          <span v-if="typeof option.extra_name === 'number'">{{
                            Label(option.extra_name)
                          }}</span
                          ><span v-else>{{ option.extra_name }}</span>
                        </div>
                      </template>
                      <template #open-indicator="{ attributes }">
                        <span v-bind="attributes"></span>
                        <button
                          type="button"
                          :disabled="changedisabled"
                          class="modallist"
                          @click="Selectproductchild(index)"
                        >
                          <b-icon icon="three-dots"></b-icon>
                        </button>
                      </template>
                      <template #selected-option="{ extra_name }">
                        <div style="position: absolute">
                          {{ extra_name }}
                        </div>
                      </template>
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                          <em
                            ><b>{{ search }}</b></em
                          >
                          {{ $t("бўйича маьлумот йўқ") }}
                          <button
                            type="button"
                            class="pluss"
                            :disabled="changedisabled"
                            @click="CreateProduct(index, search)"
                          >
                            +</button
                          ><b>Insert</b>
                        </template>
                        <em style="opacity: 0.5" v-else>{{
                          $t("Маьлумот йўқ")
                        }}</em>
                      </template>
                      <template #search="{ search, searching }">
                        <template v-if="searching">
                          <em
                            ><b>{{ search }}</b></em
                          >
                          <input
                            class="vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </template>
                    </v-select>
                  </td>
                  <td class="column1">
                    <vue-numeric
                    :disabled="changedisabled"
                      separator="space"
                      style="text-align: center;"
                      v-bind:precision="3"
                      v-model="item.count"
                      class="table-input"
                      @change="Changecountchild(index)"
                    ></vue-numeric>
                  </td>
                  <td class="column1" style="text-align: center;">
                    {{ item.current_balance | numFormat }}
                  </td>
                  <td class="column1" style="text-align: center;">
                    {{ item.price | numFormat }}
                  </td>
                  <td class="column1-5 kol">{{ item.summa | numFormat }}</td> 
                  <td class="column0">
                    <a v-if="changedisabled==false"
                        href="javascript:void(0)"
                        class="circul trash"
                        @click="Trashitemchild(index)"
                      >
                        <b-icon icon="trash"></b-icon>
                      </a>
                  </td>
                </tr>
              </div>
            </tbody>
          </table>
          </md-card-content>
          </md-card>
        </div>  
      </div>
    </div>
    <div class="row">
      <div class="col-md-2"></div>
      <div class="col-md-1 topminus end">
        <span>{{$t('Сони')}}</span>
      <h4>{{datas.count_all}}</h4>
      </div>
      <div class="col-md-2 topminus end">
        <span>Сумма</span>
        <h4>{{datas.debit_summa}}</h4>
      </div>
      <div class="col-md-7 end topminus formbottom">
        <button :disabled="changedisabled" class="btn btn-success needt" type="button" @click="Savedokument('save')">
            {{ $t("Сақлаш") }}
          </button>
          <button :disabled="changedisabled" class="mybtn btn saved needt" type="button" @click="Savedokument()">
            {{ $t("Сақлаш ва беркитиш") }}<sup>crl+enter</sup>
          </button>
      </div>
    </div>
    <b-modal
      id="modal-calculation"
      title="Товар"
      hide-footer
      size="xl"
      @shown="Shoved"
      @hidden="Hide()"
    >
      <div class="row">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>№</th>
              <th>{{ $t("Вақт") }}</th>
              <th>{{ $t("Сони") }}</th>
              <th>Комментарий</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in calculations" :key="index">
            <tr  @click="SetCalculation(item)">
              <td>{{ index + 1 }}</td>
              <td>
                <button type="button" class="atable">
                  {{ Dates(item.created_at) }}
                </button>
              </td>
              <td>{{ item.count_all }}</td>
              <td>{{ item.comment }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>
<script>
// import VueAutoVirtualScrollList from "vue-auto-virtual-scroll-list";
import { print } from "../../components/mixins/print.js";
import $ from "jquery";
export default {
  // components: { VueAutoVirtualScrollList },
  name: "ProductionForm",
  mixins: [print],
  data() {
    return {
      calculations: [],
      settedindex: 0,
      sklad: "",
      paytype: "",
      filter: "",
      focusset: "",
      pricesettings:'',
      table_type:"default",
      skladlist: [],
    };
  },
  props: ["datas"],
  created: function() {
    let self = this;
    self.$root.$refs.production = self;
    axios.get("api/v1/sklads/id/1").then(function (response) {
          self.pricesettings = { common_price_type: response.data.common_price_type, chakana_price_type: response.data.chakana_price_type, optom_price_type: response.data.optom_price_type };
          if(response.data.common_price_type==1){
            self.datas.pay_type_id=1;
          }else{
            self.datas.pay_type_id=3;
          }
        });
    self.$root.$on("skladone", function(getdata) {
      self.sklad = getdata;
    });
    self.$root.$on("skladall", function(getdata) {
      self.skladlist = getdata;
    });
    (window.onstorage = () => {
      if (localStorage.getItem("setted_product") > 0) {
        this.Productlist();
        if(this.table_type=='default'){
          this.datas.production_doc_calc[this.$store.state.selected_index].product_id = parseInt(localStorage.getItem("setted_product"));
          if (this.$store.state.selected_index != null) {
            this.Productchange(this.$store.state.selected_index);
          }
          localStorage.setItem("setted_product", 0);
          setTimeout(() => {
            this.Next();
          }, 1000);
        }else{
          if (this.$store.state.selected_index != null) {
            console.log('birinchi');
          this.datas.production_doc_calc[this.settedindex].production_doc_product[this.$store.state.selected_index].product_id = parseInt(localStorage.getItem("setted_product"));
          this.Productchangechild(this.$store.state.selected_index);
          }
        localStorage.setItem("setted_product", 0);
        setTimeout(() => {
          this.Next();
        }, 1000);
        }
      }
    }),
      setTimeout(() => {
        localStorage.setItem("sklad_id_dok", this.datas.sklad_id);
        localStorage.setItem("created_at_dok", this.datas.created_at);
      }, 1000);
  },
  mounted: function() {
    this.Focus();
    this.SetRule('/production/index');
    $("body").keydown(function(e) {
       if(e.keyCode==113){
          $(".addrowchild").click();
          return false;
      } else {
        return true;
      }
    });
  },
  methods: {
    ChangeRasxod(index){
      console.log('6');
      var item = this.datas.production_doc_calc[index];
      item.debit_price=item.seryo_summa+item.rasxod_summa;
      this.Changeprice(index);
    },
    Upproduct(){
      console.log('7');
      let self=this;
      if(self.settedindex!=0){
        self.settedindex-=1;
      }else{
        self.settedindex=self.datas.production_doc_calc.length-1;
      }
      let table=$('.producttable tbody').find('tr').eq(self.settedindex);
      table.find('.vs__search').eq(0).focus();
    },
    Downproduct(){
      console.log('8');
      let self=this;
      if(self.settedindex!=self.datas.production_doc_calc.length-1){
        self.settedindex+=1;
      }else{
        self.settedindex=0;
      }
      let table=$('.producttable tbody').find('tr').eq(self.settedindex);
      table.find('.vs__search').eq(0).focus();
    },
    CreateProduct(index, search) {
      console.log('9');
      localStorage.setItem("product_name", search);
      localStorage.setItem("shtrix_code", this.datas.production_doc_calc[index].shtrix_kod);
      this.$store.state.selected_index = index;
      let routeData = this.$router.resolve({ name: "Товар модал create" });
      window.open(routeData.href, "_blank", "width=1200, height=1000");
    },
    handlerClose: function(event) {
      console.log('10');
      if (this.$store.state.saved == null) {
        this.$store.state.saved = null;
      } else {
        const answer = window.confirm(
          this.$t("Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?")
        );
        if (answer) {
          this.Savedokument();
          event.returnValue = "";
        } else {
          this.$store.state.saved = null;
        }
      }
    },
    Autoadd(index) {
      console.log('11');
      if (this.datas.production_doc_calc.length == index + 1) {
        this.Addtable();
      }
    },
    async SetCalculation(item){
      let self=this;
      console.log('12');
      let table=self.datas.production_doc_calc[self.settedindex].production_doc_product;
      console.log('ikki');
      self.datas.production_doc_calc[self.settedindex].calculation_id=item.id;
      await item.calculation_table.forEach(element => {
        axios({
        method: "post",
        url: "api/v1/product/price-balance",
        data: { product_id: element.product_id, sklad_id: self.datas.sklad_id }
      }).then(function(response) {
        if(element.count>response.data.balance){  
          element.count=response.data.current_balance;
          self.$store.state.errors=self.$t('Қолдиқ мавжуд эмас');
        }
        if(element.count>0){
          self.datas.production_doc_calc[self.settedindex].production_doc_product.push({
        product_id: element.product_id,
				count: element.count,
        norma:element.count/item.count_all,
				price: response.data.body_price,
				summa: response.data.body_price*element.count,
				current_balance: response.data.balance
      });
        }
      
      });
      });
      setTimeout(() => {
         self.Summachild();
      }, 1000);
      self.$bvModal.hide('modal-calculation')
    },
    Shoved() {
      let self = this;
      console.log('13');
      $(document).on("focusout", function(e) {
        if ($(e.target).attr("class") == "vs__search") {
          if (self.focusset == "") {
            self.focusset = e.target;
          }
        }
      });
      $('.atable').eq(0).focus();
    },
    Hide() {
      console.log('14');
      let self = this;
      setTimeout(function(e) {
        var classs = $(":focus");
        var rrr = $("body")
          .find("input,select,textarea,button")
          .filter(":visible");
        if (classs.attr("class") == "vs__search") {
          if (
            $(self.focusset)
              .siblings(".vs__selected")
              .attr("class") != undefined
          ) {
            var focused = rrr.eq(rrr.index(classs) + 2);
            focused.focus();
          } else {
            $(self.focusset).focus();
          }
        } else if (classs.attr("class") == undefined) {
          if (
            $(self.focusset)
              .siblings(".vs__selected")
              .attr("class") != undefined
          ) {
            focused = rrr.eq(rrr.index($(self.focusset)) + 3);
            focused.focus();
          } else {
            $(self.focusset).focus();
          }
        }
      }, 100);
    },
    Trashitem(index) {
      console.log('15');
      const answer = window.confirm(this.$t("Malumotlar ochirilsinmi?"));
      console.log('uch');
      if (answer) {
        this.datas.debit_summa -= this.datas.production_doc_calc[index].debit_summa;
        this.datas.count_all -= this.datas.production_doc_calc[index].count;
        this.datas.production_doc_calc.splice(index, 1);
      }
    },
    Trashitemchild(index) {
      console.log('16');
      const answer = window.confirm(this.$t("Malumotlar ochirilsinmi?"));
      if (answer) {
        this.datas.production_doc_calc[this.settedindex].production_doc_product.splice(index, 1);
        this.Summachild();
      }
    },
    Productchange(index) {
      console.log('17');
      let self = this;
      var item = self.datas.production_doc_calc[index];
      item.optom_price = 0;
      item.chakana_price = 0;
      self.settedindex=index;
      axios({
        method: "post",
        url: "api/v1/product/price-balance",
        data: { product_id: item.product_id, sklad_id: self.datas.sklad_id }
      }).then(function(response) {
        if (self.datas.pay_type_id == 3) {
            item.current_balance = response.data.balance;
            if (response.data.optom_dollar_price) {
              item.optom_dollar_price = response.data.optom_dollar_price;
              // item.optom_price = response.data.optom_dollar_price*self.datas.dollar_rate;
              item.optom_price = response.data.optom_price;
            }
            if (response.data.chakana_dollar_price) {
              item.chakana_dollar_price = response.data.chakana_dollar_price;
              // item.chakana_price = response.data.chakana_dollar_price*self.dollar_rate;
              item.chakana_price = response.data.chakana_price;
            }
            if (response.data.price_type == 2) {
              item.debit_price = response.data.body_price;
              item.seryo_summa = response.data.body_price;
            } else if (response.data.price_type == 1) {
              window.alert(
                self.$t("Bu tovar avval boshqa valutada kelgan")
              );
            }
          } else {
            item.current_balance = response.data.balance;
            if (response.data.optom_dollar_price) {
              item.optom_dollar_price = response.data.optom_dollar_price;
              // item.optom_dollar_price = response.data.optom_price/self.datas.dollar_rate;
              item.optom_price = response.data.optom_price;
            }
            if (response.data.chakana_dollar_price) {
              item.chakana_dollar_price = response.data.chakana_dollar_price;
              // item.chakana_dollar_price = response.data.chakana_price/self.dollar_rate;
              item.chakana_price = response.data.chakana_price;
            }
            if (response.data.price_type == 1) {
              item.debit_price = response.data.body_price;
              item.seryo_summa = response.data.body_price;
            } else if (response.data.price_type == 2) {
              window.alert(
                self.$t("Bu tovar avval boshqa valutada kelgan")
              );
            }
          }
        setTimeout(() => {
          self.Changeprice(index);
        }, 100);
      });
        axios({
          method: "get",
          url: "api/v1/calculation/product/"+item.product_id
        }).then(function(response) {
          if(response.data.length>0){
            self.calculations = response.data;
            self.$bvModal.show('modal-calculation');
          }
        });
    },
    Productchangechild(index) {
      console.log('18');
      let self = this;
      var item = self.datas.production_doc_calc[this.settedindex].production_doc_product[index];
      axios({
        method: "post",
        url: "api/v1/product/price-balance",
        data: { product_id: item.product_id, sklad_id: self.datas.sklad_id }
      }).then(function(response) {
        item.current_balance = response.data.balance;
        item.price = response.data.body_price;
        setTimeout(() => {
          self.Changepricechild(index);
        }, 100);
      });
    },
    Changepricechild(index){
      console.log('19');
      let self = this;
      var item = self.datas.production_doc_calc[this.settedindex].production_doc_product[index];
      if(item.count>0){
        item.summa=item.price*item.count;
        self.Summachild();
      }
    },
    Changecountchild(index){
      let self = this;
      console.log('20');
      var item = self.datas.production_doc_calc[this.settedindex].production_doc_product[index];
      if(item.count>item.current_balance){  
          item.count=item.current_balance;
          self.$store.state.errors=self.$t('Қолдиқ мавжуд эмас');
      }
      if(item.price>0){
        item.summa=item.price*item.count;
        self.Summachild();        
      }
    },
    Summachild(){
      console.log('21');
      let self = this;
      var parent = self.datas.production_doc_calc[this.settedindex];
      parent.seryo_summa = 0;
      parent.production_doc_product.forEach(function(key, value) {
        parent.seryo_summa += parseFloat(key.norma*key.price);
      });
      setTimeout(() => {
        self.ChangeRasxod(self.settedindex);
      }, 1000);
    },
    Focus() {
      console.log('22');
      if (this.$route.path == "/production/create") {
        setTimeout(() => {
        $('.vs__search').eq(1).focus();
      }, 100);
      } else {
        setTimeout(() => {
          $('.vs__search').eq(1).focus();   
        }, 100);
        
      }
    },
    Selectproduct(index,type='default') {
      console.log('23');
      this.table_type=type;
      this.$store.state.selected_index = index;
      let routeData = this.$router.resolve({ name: "Товар модал" });
      window.open(routeData.href, "_blank", "width=1200, height=1000");
    },
    Changeprice(index) {
      console.log('24');
      var item = this.datas.production_doc_calc[index];
      let self=this;
      if (self.datas.pay_type_id == 3) {
          if (item.chakana_dollar_price > 0) {
            self.Changepricechakanadollar(index);
          }
          if (item.optom_dollar_price > 0) {
            self.Changepriceoptomdollar(index);
          }
        } else {
          if (item.optom_price > 0) {
            this.Changepriceoptom(index);
          }
          if (item.chakana_price > 0) {
            this.Changepricechakana(index);
          }
        }
      item.debit_summa = item.debit_price * item.count;
      this.Summa();
    },
    Changepricechakanadollar(index) {
      console.log('25');
        var item = this.datas.production_doc_calc[index];
        if (item.debit_price > 0) {
          if (this.datas.pay_type_id == 3) {
            item.chakana_price = item.chakana_dollar_price * this.datas.dollar_rate;
            item.chakana_percent = parseFloat((item.chakana_dollar_price / item.debit_price) * 100 - 100).toFixed(2);
            item.chakana_summa = item.chakana_price * item.count;
          } else {
            item.chakana_price = item.chakana_dollar_price * this.datas.dollar_rate;
            item.chakana_percent = parseFloat((item.chakana_price / item.debit_price) * 100 - 100).toFixed(2);
            item.chakana_summa = item.chakana_price * item.count;
          }
        }
      },
    Changepriceoptomdollar(index) {
      console.log('26');
      var item = this.datas.production_doc_calc[index];
      if (item.debit_price > 0) {
        if (this.datas.pay_type_id == 3) {
          item.optom_price = item.optom_dollar_price * this.datas.dollar_rate;
          item.optom_percent = parseFloat((item.optom_dollar_price / item.debit_price) * 100 - 100).toFixed(2);
          item.optom_summa = item.optom_price * item.count;
        } else {
          item.optom_price = item.optom_dollar_price * this.datas.dollar_rate;
          item.optom_percent = parseFloat((item.optom_price / item.debit_price) * 100 - 100).toFixed(2);
          item.optom_summa = item.optom_price * item.count;
        }
      }
    },
    Changecount(index) {
      console.log('27');
      var item = this.datas.production_doc_calc[index];
      if (item.debit_price > 0) {
        item.debit_summa = item.count * item.debit_price;
      }
      if (item.optom_price > 0) {
        item.optom_summa = item.count * item.optom_price;
      }
      if (item.chakana_price > 0) {
        item.chakana_summa = item.count * item.chakana_price;
      }
      item.production_doc_product.forEach(function(key, value) {
        key.count=parseFloat(key.norma)*parseFloat(item.count);
        if(key.count>key.current_balance){  
          key.count=key.current_balance;
          item.count=parseFloat(key.count)/parseFloat(key.norma)
          self.$store.state.errors=self.$t('Қолдиқ мавжуд эмас');
          self.Changecount(index);
        }
        key.summa=key.count*key.price;
      });
      this.Summa();
    },
    Changepercentoptom(index) {
      console.log('28');
      var item = this.datas.production_doc_calc[index];
      if (this.datas.pay_type_id == 3) {
          item.optom_dollar_price = item.debit_price * (item.optom_percent / 100 + 1);
          item.optom_price = item.optom_dollar_price * this.datas.dollar_rate;
          item.optom_summa = item.optom_price * item.count;
        } else {
          item.optom_price = item.debit_price * (item.optom_percent / 100 + 1);
          item.optom_summa = item.optom_price * item.count;
          item.optom_dollar_price = item.optom_price / this.datas.dollar_rate;
        }
    },
    Changepercentchakana(index) {
      console.log('29');
      var item = this.datas.production_doc_calc[index];
      if (this.datas.pay_type_id == 3) {
          item.chakana_dollar_price = item.debit_price * (item.chakana_percent / 100 + 1);
          item.chakana_price = item.chakana_dollar_price * this.datas.dollar_rate;
          item.chakana_summa = item.chakana_price * item.count;
        } else {
          item.chakana_price = item.debit_price * (item.chakana_percent / 100 + 1);
          item.chakana_summa = item.chakana_price * item.count;
          item.chakana_dollar_price = item.chakana_price / this.datas.dollar_rate;
        }
    },
    Changepriceoptom(index) {
      console.log('30');
      var item = this.datas.production_doc_calc[index];
      if (item.debit_price > 0) {
          if (this.datas.pay_type_id == 3) {
            item.optom_dollar_price = item.optom_price / this.datas.dollar_rate;
            item.optom_percent = parseFloat((item.optom_dollar_price / item.debit_price) * 100 - 100).toFixed(2);
            item.optom_summa = item.optom_price * item.count;
          } else {
            item.optom_percent = parseFloat((item.optom_price / item.debit_price) * 100 - 100).toFixed(2);
            item.optom_summa = item.optom_price * item.count;
            item.optom_dollar_price = item.optom_price / this.datas.dollar_rate;
          }
        }
    },
    Changepricechakana(index) {
      var item = this.datas.production_doc_calc[index];
      if (item.debit_price > 0) {
          if (this.datas.pay_type_id == 3) {
            item.chakana_dollar_price = item.chakana_price / this.datas.dollar_rate;
            item.chakana_percent = parseFloat((item.chakana_dollar_price / item.debit_price) * 100 - 100).toFixed(2);
            item.chakana_summa = item.chakana_price * item.count;
          } else {
            item.chakana_percent = parseFloat((item.chakana_price / item.debit_price) * 100 - 100).toFixed(2);
            item.chakana_summa = item.chakana_price * item.count;
            item.chakana_dollar_price = item.chakana_price / this.datas.dollar_rate;
          }
        }
    },
    Addtable() {
      console.log('32');
      this.datas.production_doc_calc.push({
        calculation_id : 0,
        product_id : 0,
        current_balance: 0,
        count : 0,
        debit_price : 0,
        debit_summa : 0,
        chakana_percent : 0,
        optom_percent : 0,
        chakana_price : 0,
        optom_price : 0,
        chakana_summa : 0,
        optom_summa : 0,
        norma: 1,
        chakana_dollar_price:0,
        optom_dollar_price:0,
        rasxod_summa:0,
        seryo_summa:0,
        production_doc_product: [],
        norma:0
      });
      this.Tablefocus();
    },
    Addtablechild() {
      console.log('33');
      this.datas.production_doc_calc[this.settedindex].production_doc_product.push({
        product_id: 0,
				count: 0,
				price: 0,
				summa: 0,
				current_balance: 0,
        norma:0
      });
      setTimeout(() => {
        $("tbody>div").scrollTop(10000);
        var rr=$('tbody').eq(1).find('tr').eq(-1).find('input').eq(0);
        rr.focus();   
      }, 500);
    },
    Summa() {
      console.log('34');
      this.datas.debit_summa = 0;
      this.datas.count_all = 0;
      let self = this;
      this.datas.production_doc_calc.forEach(function(key, value) {
        self.datas.debit_summa += parseFloat(key.debit_summa);
        self.datas.count_all += parseFloat(key.count);
      });
    },
    Savedokument(type = "default") {
      let self = this;
            if(self.rule.change==true){
      if (this.$route.path == "/production/create") {
        var methods = "post";
        var action = "api/v1/production-doc";
        self.Summa();
      } else {
        var methods = "patch";
        var action = "api/v1/production-doc/id/" + self.$route.params.id;
        if(self.$store.state.saved==1){
          self.Summa();
          self.datas.updated_at = new Date()
        .valueOf()
        .toString()
        .slice(0, 10);
        }
      }
      axios({
        method: methods,
        url: action,
        data: self.datas
      }).then(function(response) {
        self.$store.state.saved = null;
        if (type == "save") {
          self.$router.push({ path: "/production/update/" + response.data.id });
        }
        else {
          self.$router.push({ name: "Ишлаб чиқариш" });
        }
      });
       } else{
          self.$store.state.errors=self.$t('Sizdan bunday xuquq mavjud emas');
    }
    }
  }
};
</script>
